import { ConfigProvider, Segmented } from "antd";
import { colors } from "shared/theme/color";
import { SalesTrendMonths } from "shared/types";
import { translate } from "shared/languages";

interface TrendMonthsSegmentedProps {
  value: SalesTrendMonths;
  onChange: (value: SalesTrendMonths) => void;
  // Pass false when a sibling CustomMonthRangePicker's range is actually
  // active — same rationale as RangeSegmented's `active` prop (see there):
  // Segmented has no true "nothing selected" state, so this fades the
  // highlight rather than unsetting it. Defaults to true.
  active?: boolean;
}

// Same visual theme as RangeSegmented — months instead of days, since a
// revenue trend wants calendar-month buckets, not a rolling day window.
const TrendMonthsSegmented = ({ value, onChange, active = true }: TrendMonthsSegmentedProps) => (
  <ConfigProvider
    theme={{
      components: {
        Segmented: {
          trackBg: colors.bgSoft,
          trackPadding: 4,
          itemColor: colors.ink2,
          itemHoverColor: colors.ink,
          itemSelectedBg: active ? colors.card : "transparent",
          itemSelectedColor: active ? colors.ink : colors.ink2,
          borderRadius: 999,
          borderRadiusSM: 999,
        },
      },
      token: {
        boxShadowTertiary: "0 1px 2px rgba(15, 15, 14, 0.10)",
      },
    }}
  >
    <Segmented<SalesTrendMonths>
      value={value}
      onChange={(val) => onChange(val as SalesTrendMonths)}
      options={[
        { label: translate("analyticsPage.sales.trend_months_3"), value: 3 },
        { label: translate("analyticsPage.sales.trend_months_6"), value: 6 },
        { label: translate("analyticsPage.sales.trend_months_12"), value: 12 },
        { label: translate("analyticsPage.sales.trend_months_ytd"), value: "ytd" },
      ]}
    />
  </ConfigProvider>
);

export default TrendMonthsSegmented;
